// @ts-check
import PropTypes from "prop-types";
import { Small, Flex } from "orcs-design-system";

/**
 * @returns {React.ReactElement}
 */
export const AIWarning = ({ justifyContent = "center", mb = "0" }) => {
  return (
    // @ts-ignore -- orcs Flex/Small require theme prop via ThemeProvider, not direct prop
    <Flex
      flex="1 1 auto"
      alignItems="center"
      mb={mb}
      justifyContent={justifyContent}
    >
      {/* @ts-ignore -- orcs Small requires theme via ThemeProvider */}
      <Small color="greyDark" fontSize="0">
        <em>This is AI-generated content. Be sure to fact-check.</em>
      </Small>
    </Flex>
  );
};

AIWarning.propTypes = {
  justifyContent: PropTypes.string,
  mb: PropTypes.string,
};
